import { ApiService } from '@libs/core/base-config';
import { Dtos, userSchema } from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function loggedInUser(apiService: ApiService) {
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/users/logged-in-user`, {})
    .pipe(map((data) => userSchema().parse(data)));
}

export function addToWishlist(apiService: ApiService, { productId }: Dtos.AddToWishlistPathParams) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/users/add-to-wishlist/${productId}`, {});
}

export function removeFromWishlist(apiService: ApiService, { productId }: Dtos.RemoveFromWishlistPathParams) {
  return apiService.http.delete<void>(`${apiService.baseUrl}/api/v1/users/remove-from-wishlist/${productId}`, {});
}

export function addAddress(
  apiService: ApiService,
  { label, street, internalAddress, phone, phone2, latitude, longitude }: Dtos.AddAddressBody,
) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/users/add-address`, {
    label,
    street,
    internalAddress,
    phone,
    phone2,
    latitude,
    longitude,
  });
}

export function updateAddress(
  apiService: ApiService,
  { label, street, internalAddress, phone, phone2, latitude, longitude }: Dtos.UpdateAddressBody,
  { addressId }: Dtos.UpdateAddressPathParams,
) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/users/update-address/${addressId}`, {
    label,
    street,
    internalAddress,
    phone,
    phone2,
    latitude,
    longitude,
  });
}

export function deleteAddress(apiService: ApiService, { addressId }: Dtos.DeleteAddressPathParams) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/users/delete-address/${addressId}`, {});
}

export function addFcmToken(apiService: ApiService, { token }: Dtos.AddFCMTokenBody) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/users/add-fcm-token`, { token });
}

export function removeFcmToken(apiService: ApiService, { token }: Dtos.RemoveFCMTokenBody) {
  return apiService.http.put<void>(`${apiService.baseUrl}/api/v1/users/remove-fcm-token`, { token });
}
